import { render } from "./EventList.vue?vue&type=template&id=4e07773a&scoped=true"
import script from "./EventList.vue?vue&type=script&lang=ts"
export * from "./EventList.vue?vue&type=script&lang=ts"

import "./EventList.vue?vue&type=style&index=0&id=4e07773a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4e07773a"

export default script